// extracted by mini-css-extract-plugin
module.exports = {"market":"Market_market__2SIyJ","table":"Market_table__xpMkz","row":"Market_row__1GtrP","col":"Market_col__zR4Vg","foot":"Market_foot__1vs_6","arrow":"Market_arrow__3fneO"};